import { memo } from 'react'

import { FeatureElement } from '@/entities/feature'
import { cn } from '@/shared/lib/cn'

import { useOfferCardFeatures } from '../../model/useOfferCardFeatures'
import { OfferCardInnerProps } from '../../types/OfferCardInnerProps.ts'

interface OfferCardFeaturesProps extends OfferCardInnerProps {
	forceFeaturesIsClickable?: boolean
	showSelectedOption?: boolean
}

/**
 * Show features in offer card
 *
 * @author Ivan Shchedrovskyi
 */
export const OfferCardFeatures = memo(
	({
		offer,
		forceFeaturesIsClickable,
		showSelectedOption,
		className
	}: OfferCardFeaturesProps) => {
		const features = useOfferCardFeatures(offer)

		return (
			<div className={cn('mt-3 flex flex-col gap-y-1.5', className)}>
				{features?.map(feature => (
					<FeatureElement
						key={feature.name}
						feature={feature}
						forceIsClickable={forceFeaturesIsClickable}
						showSelectedOption={showSelectedOption}
					/>
				))}
			</div>
		)
	}
)

OfferCardFeatures.displayName = 'OfferCardFeatures'
